import axios from 'axios'

let baseUrl;
if(process.env.NODE_ENV == 'development'){
    // baseUrl = "http://localhost/CherrytreeBackend/sites/cherrytree.lan/html/c2/ws/call.php"  // Localhost
    baseUrl = "/c2/ws/call.php"
}else{
    //production
    baseUrl = "/c2/ws/call.php"
    // Josh you can use this if the app is deployed on a different url to the backend
    // baseUrl = "https://members.cherrytree.co.nz/c2/ws/call.php"
}

//one instance of created for all usages
export const myaxios = axios.create({
    baseURL: baseUrl,
    withCredentials: true,
})

export default myaxios;


//gave up on caching because it was too much work for not enough reward
//
// import store from '@/store'
// const cachios = require('cachios');
// const NodeCache = require('node-cache');


// import { setupCache } from 'axios-cache-adapter'
// import localforage from 'localforage'
// import memoryDriver from 'localforage-memoryStorageDriver'

// //store for cache allows results to be persisted between sessions
// const cacheStore = localforage.createInstance({
//   // List of drivers used
//   driver: [
//     localforage.INDEXEDDB, 
//     localforage.LOCALSTORAGE,
//     memoryDriver._driver
//   ],
//   // Prefix all storage keys to prevent conflicts
//   name: 'cherrytree-cache-1'
// })

// // // TODO set cache rules sensibly
//TODO ensure caching works when membership level changes

// let cacheKey = 0

// const cache =  setupCache({
//     maxAge: 60 * 60 * 1000, //60 minutes
//     exclude: { query: false },
//     key: req => req.url + JSON.stringify(req.params) + JSON.stringify(store.state.auth.loggedIn) + cacheKey.toString(), 
//     //cache is effectively cleared when user changes login state, or key is incremented
//     // store: cacheStore
// })

// cachios.getCacheIdentifier = function (config) {
//     console.log(store.state.auth.loggedIn, "logged in======")
//     return {
//         method: config.method,
//         url: config.url,
//         params: config.params,
//         data: config.data,
//         headers: config.headers,
//         cacheKey: cacheKey.toString() + ' ' + JSON.stringify(store.state.auth.loggedIn)

//     };
// };


// const cachedAxios = cachios.create(myaxios);
//reset cache by assigning new one
// export const resetCache = () => {
//     cachedAxios.cache = new NodeCache({
//       stdTTL: 0, //standard time to live in seconds
//       checkperiod: 120, //period to check for expired cach entries and remove them in seconds
//     });
// }